module.exports = __webpack_public_path__ + "assets/token-icon.5e18b876.svg";